import React from "react";
import {withRouter} from "react-router-dom";
import './PageAuth.css';
import {Mutation} from "react-apollo";
import { SIGNIN_USER, RECOVERY_PASSWORD } from "../../../queries";
import axios from "axios";
const bcrypt = require('bcryptjs');


class PageAuth extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            SITE_ADDRESS: "https://launch.artyfact.game",
            email : '',
            password : '',
            RecoveryMessage: '',
            Forgot: false,
            testemail: false,
            emailmessage: '',
            ErrorMsg: false
        };
    };

    ChangeSignInInput = event => {
        const  {name, value} = event.target;
        //console.log(name, ":", value)
        this.setState(() => ({ [name] : value }));
    };

    ChangeSignUpInputEmail = event => {
        const  {name, value} = event.target;
        let newvalue = value.toLowerCase();
        let reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,6})$/;
        if(reg.test(newvalue) == false) {
          this.setState({testemail: false});
        } else {
          this.setState({testemail: true});
        }
        if (newvalue.length > 6 && reg.test(newvalue) == false) {
            this.setState({emailmessage : 'E-mail is incorrect!'});
        } else {
            this.setState({emailmessage : ''});
        }
        this.setState(() => ({ [name] : newvalue }));
    };

    ChangeSignInInputRecovery = event => {
        const { name, value } = event.target;
        this.setState(() => ({ [name]: value }));
    };

    SubmitSignIn = (event, signinUser) => {
        event.preventDefault();
        signinUser()
        .then(async ({ data }) => {
            console.log({ data });
            localStorage.setItem('token',data.signinUser.token);
            localStorage.setItem('tokenDefault', data.signinUser.token);
            localStorage.setItem('email', this.state.email);            
            await this.props.refetch();
            window.open(this.state.SITE_ADDRESS, '_top');
            //this.props.history.push('/');
            //location.reload();
        },
        error => {
            let ErrorString = '' + error;
            let ErrorMsg = ErrorString.replace('Error: GraphQL error:', '');
            console.log(ErrorMsg);
            this.setState({ErrorMsg : ErrorMsg});
        })
    };

    SignInValidate = (event, signinUser) => {
        const { email, password } = this.state;
        const isInvalid = !email || !password;
        return isInvalid
    };

    SignInValidateForgot = (event, signinUser) => {
        const { email } = this.state;
        const isInvalid = !email;
        return isInvalid
    };

    ChangeType = (event, number) => {
        this.setState({Forgot: !this.state.Forgot});
    };

    PasswordRecovery = (event, recoveryPassword) => {
        recoveryPassword().then(async ({ data }) => {      
            console.log("data", data);     
            let NewMessage = `New password has been send to ${this.state.email}. Check your E-mail address! To login with a new password, RELOAD the authorization page!`;
            this.setState({ RecoveryMessage: NewMessage });
        });
    };

    render() {
        const { email, password } = this.state;

        return (
            <div className="PageAuth">
                <div  style={{display: this.state.Forgot ? 'none' : 'block'}}>
                    <div className="login-ttl">SIGN IN</div>
                    <Mutation mutation={SIGNIN_USER} variables={{ email, password }}>
                        {(signinUser,{data, loading, error}) => {
                            return(
                                <form className="SignInform" onSubmit={event => this.SubmitSignIn(event, signinUser)}>
                                    <div className="ForgotInput">
                                        <label>
                                            <input type="email" name="email" placeholder="&nbsp;" value={email} onChange={this.ChangeSignUpInputEmail} />
                                            <span className="TextPlaceHolder">E-mail</span>
                                        </label>
                                    </div>  
                                    <div className="ForgotInput">
                                        <label>
                                            <input type="password" name="password" placeholder="&nbsp;" value={password} onChange={this.ChangeSignInInput} />
                                            <span className="TextPlaceHolder">Password</span>
                                        </label>
                                    </div>
                                    {this.state.testemail ? (
                                        <button type="submit" className="SignInformSubmit" disabled={loading || this.SignInValidate()}>LOGIN</button>
                                    ) : (
                                        <>
                                        <button className="SignInformSubmit" disabled={true} style={{background: '#6c757d', cursor: 'default'}}>LOGIN</button>
                                        <div class="text-center mt20px" style={{color: '#ffffff'}}>{this.state.emailmessage}</div>
                                        </>
                                    )}
                                    {this.state.ErrorMsg ? (
                                        <div class="text-center mt20px" style={{color: '#ffffff'}}>{this.state.ErrorMsg}</div>
                                    ) : (
                                        <></>
                                    )}
                                </form>
                            )
                        }}

                    </Mutation>
                    <div class="text-center mt20px mb30px">
                        <a className="ForgotPass" href="#" onClick={this.ChangeType}>Forgot Password?</a>
                    </div>
                    <div class="text-center mt20px">
                        <a className="ForgotPass" href="https://artyfact.game/">Back to ARTYFACT website</a>
                    </div>
                    
                </div>
                <div  style={{display: this.state.Forgot ? 'block' : 'none'}}>
                    <div className="login-ttl">Password recovery</div>
                    <Mutation mutation={RECOVERY_PASSWORD} variables={{ email: this.state.email }}>
                        {(recoveryPassword, { data, loading, error }) => {
                            return (
                                <div className="SignInform">
                                    <div className="ForgotInput">
                                        <label>
                                            <input type="email" name="email" placeholder="&nbsp;" value={email} onChange={this.ChangeSignInInputRecovery}/>   
                                            <span className="TextPlaceHolder">E-mail</span>    
                                        </label>  
                                    </div>                                           
                                    <button className="SignInformSubmit" disabled={this.SignInValidateForgot()} onClick={event => this.PasswordRecovery(event, recoveryPassword)}>RECOVER</button>
                                </div>
                            )
                        }}
                    </Mutation>   
                    <div style={{ display: this.state.RecoveryMessage.length > 0 ? 'block' : 'none' }} className="RecoveryAlert">{this.state.RecoveryMessage}</div>                    
                    <div class="text-center mt20px">
                        <a className="ForgotPass" href="https://launch.artyfact.game/">Login</a>
                    </div>                    
                </div>
            </div>
        )}}

export default withRouter(PageAuth)

